import React, { useState } from "react";
import { Link } from "react-router-dom";
import { countryMarkets } from "../lib/catalog";
import { useSiteData } from "../lib/siteApi";

export default function HomeNav() {
  const site = useSiteData();
  const markets = countryMarkets(site.projects || []);
  const countries = markets.map((m) => m.country);
  const projectHint = countries.length ? `${countries.length} markets · photos` : "Photos of our plants";
  const [paused, setPaused] = useState(false);

  const items = [
    { to: "/about", label: "About RENERG", hint: "Our story" },
    { to: "/services/category/photovoltaic", label: "Solar energy", hint: "Off-grid & on-grid" },
    { to: "/services/category/realestate", label: "Green buildings", hint: "Design & construction" },
    { to: "/services/category/emobility", label: "E-mobility", hint: "Charging & fleets" },
    { to: "/projects", label: "Projects", hint: projectHint },
  ];
  const loop = [...items, ...items];

  return (
    <section className="relative z-20 mt-6 max-w-full pb-8 sm:-mt-16">
      <div className="container">
        <div
          className={`home-marquee rounded-[1.75rem] border border-white/70 bg-white/95 shadow-[0_18px_50px_rgba(15,23,42,0.12)] ${paused ? "is-paused" : ""}`}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={() => setPaused(true)}
          onTouchEnd={() => setPaused(false)}
          onTouchCancel={() => setPaused(false)}
        >
          <div className="home-marquee-track">
            {loop.map((item, index) => (
              <Link key={`${item.to}-${index}`} to={item.to} className="home-slide-card">
                <p className="text-sm font-semibold leading-snug text-slate-900">{item.label}</p>
                <p className="mt-1 text-xs leading-snug text-slate-500">{item.hint}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
